<template>
  <div>
    <div style="padding-left:5px">
     <el-tabs v-model="activeName"  @tab-click="handleClick">
      <el-tab-pane label="自有角色"  name="one">
        <ownRole v-if="activeName=='one'"></ownRole>
      </el-tab-pane>
      <el-tab-pane label="客户通用角色" name="two">
       <div>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="90px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
            <el-form-item label="角色名称:" prop="name">
              <el-input  placeholder="" v-model="searchFrom.name"></el-input>
            </el-form-item>
          </div>
        </div>
       <div class="searchBtnBox" style="margin-top:10px;margin-bottom:10px;">
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" v-if="btnFlg[0]"  @click="addFn">新增</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border class="tableComent">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  v-if="btnFlg[1]"    @click="editFn(scope.row)">修改</el-button>
              <el-button type="text" size="mini" v-if="btnFlg[2]"  @click="delFn(scope.row)">删除</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="name"  width="160" :formatter="emptyFn" label="角色名称"></el-table-column>
        <el-table-column property="type" label="角色类型" min-width="100">
          <template scope="scope">
            <div>
           {{[ "业务角色", "普通角色", "客户角色"][scope.row.type-1]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="isCarHold" label="用户数量" min-width="100">
          <template scope="scope">
             <el-button type="text" size="mini" btnCode="00KP002B003"   @click="yonghuFn(scope.row)">{{scope.row.number}}</el-button>
          </template>
        </el-table-column>
       <el-table-column prop="createUserName" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog  :title="title"  :close-on-click-modal="false"  :close-on-press-escape="false"  class="jiaoyan"
     :visible.sync="dialogVisible"  @close="closeDialog"  width="1100px"  center >
      <div>
        <el-form  :model="addFrom"  :rules="rules"  ref="addFrom" class="demo-form-inline"   label-width="100px"  size="mini" >
          <div class="inpBox">
            <div class="business1">
               <el-form-item label="角色名称" prop="name">
                  <el-input   maxlength="50"  :validate-event="false"  placeholder  v-model.trim="addFrom.name"  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="业务类型:" prop="businessId" style="margin-left:20px">
                    <el-cascader
                        @change="businessChange"
                        v-model="addFrom.businessId"
                        :options="yewuTree"
                        :show-all-levels="false"
                        :props="{ expandTrigger: 'hover' ,label:'name',value:'id',emitPath:false}"
                      ></el-cascader>
                </el-form-item> -->
            </div>

            <div style="border-top: 1px dashed #ddd;">
              <h5 ><i class="fa fa-bars" aria-hidden="true"></i> 角色权限</h5>
              <div class="" style="display:flex">
                <div style="width:100%">
                  <h6>WEB端模块:</h6>
                   <ul  class="ul">
                      <li v-for="(item,index) in QXList" :key="item.id" style="margin:20px">
                        <h5 ><i class="fa fa-bars" aria-hidden="true"></i> {{item.moduleName}}</h5>
                        <div class="shuBox" >
                          <el-tree
                            :data="item.sMenuTreeList"
                            show-checkbox
                            :props="defaultProps"
                            ref="menuTree"
                            node-key="id"
                            :default-expand-all="true"
                            :highlight-current="true"
                            :expand-on-click-node="false"
                            :render-content="renderContent"
                            @node-click="handleNodeClick($event,index)"
                          >
                        </el-tree>
                      </div>
                      </li>
                    </ul>
                  <p v-if="QXList.length==0" style="text-align:center">暂无数据</p>
                </div>
                <div  style="width:100%">
                  <h6>APP端模块:</h6>
                  <ul  class="ul">
                    <li v-for="(item,index) in QXListAPP" :key="item.id" style="margin:20px">
                      <h5 ><i class="fa fa-bars" aria-hidden="true"></i> {{item.moduleName}}</h5>
                      <div class="shuBox" >
                        <el-tree
                          :data="item.sMenuTreeList"
                          show-checkbox
                          :props="defaultProps"
                          ref="menuTree"
                          node-key="id"
                          :default-expand-all="true"
                          :highlight-current="true"
                          :expand-on-click-node="false"
                          :render-content="renderContent"
                          @node-click="handleNodeClick($event,index,true)"
                        >
                      </el-tree>
                    </div>
                    </li>
                  </ul>
                  <p v-if="QXListAPP.length==0" style="text-align:center">暂无数据</p>
                </div>
              </div>
            </div>
            </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn('addFrom')" >保 存</el-button>
        <el-button @click="dialogVisible=false" size="mini">取 消</el-button>
      </span>
    </el-dialog>
     <!-- 用户列表 -->
    <roleUser :row-data="row" @destroy="userFlag=false" v-if="userFlag"></roleUser>
 </div>
      </el-tab-pane>
    </el-tabs>
   </div>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sRoleList, businessTree, sRoleAdd, sRoleUpdate, sRoleDelete, sMenuListByRoleId, sMenuTreeByBusiness } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, dateFormat, arrChaJi } from '@/utils/util'
import roleUser from '@/views/newCrm/components/roleUser.vue'
import ownRole from '@/views/newCrm/components/ownRole.vue'
export default {
  components: {
    roleUser,
    ownRole
  },
  data () {
    return {
      activeName: 'one',
      // yewuTree: [],
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      QXList: [],
      QXListAPP: [],
      title: '添加角色',
      dialogVisible: false,
      dialogDetail: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: 'false',
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择角色类型', trigger: 'blur' }
        ],
        businessId: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ]
      },
      sMenuTreeList: [],
      addFrom: {
      },
      isAdd: true,
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      oldChildArr: [],
      oldAllArr: [],
      tenantCode: this.ZtenantCode,
      useTenantCode: this.ZuseTenantCode,
      row: {},
      userFlag: false,
      btnFlg: [],
      btnIdArr: ['00d0080100', '00d0080200', '00d0080300'],
      btnIdArrWH: ['00d0040901', '00d0040902', '00d0040903']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.tenantCode = localStorage.getItem('tenantCode')
    this.useTenantCode = localStorage.getItem('tenantCode')
    this.getList(this.searchFrom)
  },
  mounted () {
    this.getHight()
  },
  methods: {
    getHight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 202) + 'px'
      })
    },
    handleClick () {
      if (this.activeName == 'two') {
        this.getList(this.searchFrom)
      }
      this.getHight()
    },
    // 树得格式化
    renderContent (h, { node, data, store }) {
      if (data.aliasName && localStorage.getItem('userType') == 1) {
        return (
          <span class="custom-tree-node">
            <span style="font-size:16px">{data.name + '（' + data.aliasName + '）'}</span>
          </span>)
      } else {
        return (
          <span class="custom-tree-node">
            <span style="font-size:16px">{data.name }</span>
          </span>)
      }
    },
    // 点击字体选择取消
    handleNodeClick (data, index, isApp) {
      if (isApp) {
        index = index + this.QXList.length
      }
      console.log(index)
      let checkedArr = []
      this.$refs.menuTree.forEach((item, index) => {
        checkedArr.push(...item.getCheckedNodes(false, true))
      })
      const n = checkedArr.findIndex(d => d.id === data.id)
      if (n > -1) {
        this.$refs.menuTree[index].setChecked(data, false, true)
      } else {
        this.$refs.menuTree[index].setChecked(data, true, true)
      }
    },
    // 用户
    yonghuFn (row) {
      this.row = row
      this.userFlag = true
    },
    // 添加
    addFn () {
      this.title = '添加角色'
      this.addFrom = {
      }
      // businessTree({ flag: 4, tenantCode: localStorage.getItem('tenantCode') }).then(res => {
      //   this.yewuTree = this.sAttributeList(res)
      // })

      sMenuTreeByBusiness({
        tenantCode: this.tenantCode
        // useTenantCode: this.useTenantCode
      }).then(res => {
        this.QXList = res.webList
        this.QXListAPP = res.appList
      })
      this.dialogVisible = true
      this.isAdd = true
    },
    // businessChange () {
    //   sMenuTreeByBusiness({
    //     businessId: this.addFrom.businessId
    //   }).then(res => {
    //     this.QXList = res.webList
    //     this.QXListAPP = res.appList
    //   })
    // },
    // 修改
    editFn (row) {
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      this.addFrom = {
        name: row.name,
        id: row.id,
        type: row.type,
        tenantCode: row.tenantCode,
        useTenantCode: row.useTenantCode
      }
      // businessTree({ falg: 4, tenantCode: localStorage.getItem('tenantCode') }).then(res => {
      //   this.yewuTree = this.sAttributeList(res)
      // })

      sMenuTreeByBusiness({
        tenantCode: this.tenantCode
        // useTenantCode: this.useTenantCode
      }).then(res => {
        this.QXList = res.webList
        this.QXListAPP = res.appList
        huixian(this)
      })

      function huixian (that) {
        sMenuListByRoleId({ roleId: row.id }).then(res1 => {
          that.$nextTick(function () {
            that.$refs.menuTree.forEach((item, index) => {
              item.setCheckedKeys(res1.menuChildAllList)
            })
          })
          that.oldChildArr = res1.menuChildAllList
          that.oldAllArr = res1.menuAllList
        })
      }
    },
    // 递归判断列表，把最后的children设为undefined
    sAttributeList (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.sAttributeList(data[i].children)
        }
      }
      return data
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          let checkedArr = []
          let checkedChIds = []
          if (this.QXList.length > 0 || this.QXListAPP.length > 0) {
            this.$refs.menuTree.forEach((item, index) => {
              checkedArr.push(...item.getCheckedNodes(false, true))
              checkedChIds.push(...item.getCheckedKeys(true))
            })
          }
          if (checkedArr.length == 0) {
            this.$alert('请选择菜单', '系统提示')
            return
          }
          let menuIds = []
          checkedArr.forEach(item => {
            menuIds.push(item.id)
          })
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.addFrom.type = 3
            this.addFrom.parentMenuIds = arrChaJi(menuIds, checkedChIds, 1)// 取两个数组得差集
            this.addFrom.childMenuIds = checkedChIds
            this.addFrom.tenantCode = this.tenantCode
            this.addFrom.useTenantCode = this.useTenantCode
            sRoleAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            this.addFrom.childMenuIds = arrChaJi(this.oldChildArr, checkedChIds, 2)// 新增得子
            let addAllArr = arrChaJi(this.oldAllArr, menuIds, 2)// 新增得全部
            this.addFrom.parentMenuIds = arrChaJi(this.addFrom.childMenuIds, addAllArr, 2)// 新增得父
            this.addFrom.delMenuIds = arrChaJi(this.oldAllArr, menuIds, 1)// 删除得全部
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sRoleUpdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 树得格式化
    renderContent (h, { node, data, store }) {
      if (data.aliasName) {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">{data.name + '（' + data.aliasName + '）'}</span>
          </span>)
      } else {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">{data.name }</span>
          </span>)
      }
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.tenantCode = this.tenantCode
      this.searchFrom.useTenantCode = this.useTenantCode
      this.searchFrom.type = 3
      sRoleList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 删除
    delFn  (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sRoleDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.addFrom = {

      }
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
      if (this.$refs.menuTree) {
        this.$refs.menuTree.forEach((item, index) => {
          item.setCheckedKeys([])
        })
      }
    }
  }
}
</script>

<style scoped lang='less'>
.ul{
  width: 45;
  display: flex;
  flex-wrap: wrap;
  li{
    width: 100%;
  }
  h5{
    margin: 0;
    margin-bottom: 20px;
  }
  .fa{
    color:#0c46a2;
  }
}
.fa{
  color:#0c46a2;
}
/deep/.el-tag{
  margin-right:20px;
}
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/.inpBox .el-input__inner{
  width:180px;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/.el-checkbox__inner{
      width: 18px;
    height: 18px;
    margin-right: 10px;
}
/deep/.el-checkbox__inner::after{
    height: 9px;
    left: 6px;
    top: 1px;
}
.business1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
